<template>
    <div class="flex flex-col">
      <div class="overflow-auto flex-1 StepsView scroll-smooth" ref="stepWindow">
        <template v-if="isLoading">
          <div class="w-full h-full flex items-center justify-center">
            <div class="">
              <ActivityIndicator />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="relative chart-container">
            <div
              class="lg:sticky"
              v-if="
                computedChartData.datasets[0].data.reduce((a, b) => a + b, 0) != 0
              "
            >
              <Pie
                class="chart-content m-auto"
                v-if="forceRerenderChart"
                :data="updatedChartData"
                :options="chartOptions"
              />
            </div>
            <div
              class="mt-4 lg:sticky"
              :class="{
                'opacity-0':
                  computedChartData.datasets[0].data.reduce((a, b) => a + b, 0) ==
                  0,
              }"
            >
              <div class="content-container flex justify-center">
                <div>
                  <div
                    class="font-epilogue text-primary-400 text-center"
                    v-if="personnelBudgetTotal > 0"
                  >
                    <div class="square-container">
                      <p
                        class="square mr-1"
                        :style="{ backgroundColor: getBackgroundColor(1) }"
                      ></p>
                      <p
                        :style="{
                          color: selectedBodyTextColor,
                          fontFamily: selectedFontFamily,
                        }"
                      >
                        Personnel :
                        {{ formatToDecimal(personnelBudgetTotal - 0) }}
                      </p>
                    </div>
                  </div>
                  <div class="square-container" v-if="professionalContractualBudgetTotal > 0">
                    <p
                      class="square mr-1"
                      :style="{ backgroundColor: getBackgroundColor(2) }"
                    ></p>
                    <p
                      :style="{
                        color: selectedBodyTextColor,
                        fontFamily: selectedFontFamily,
                      }"
                    >
                      Professional and Contractual Fees :
                      {{ formatToDecimal(professionalContractualBudgetTotal - 0) }}
                    </p>
                  </div>
                  <div class="square-container" v-if="printingBudgetTotal > 0">
                    <p
                      class="square mr-1"
                      :style="{ backgroundColor: getBackgroundColor(3) }"
                    ></p>
                    <p
                      :style="{
                        color: selectedBodyTextColor,
                        fontFamily: selectedFontFamily,
                      }"
                    >
                      Printing :
                      {{ formatToDecimal(printingBudgetTotal - 0) }}
                    </p>
                  </div>
                  <div class="square-container" v-if="travelBudgetTotal > 0">
                    <p
                      class="square mr-1"
                      :style="{ backgroundColor: getBackgroundColor(4) }"
                    ></p>
                    <p
                      :style="{
                        color: selectedBodyTextColor,
                        fontFamily: selectedFontFamily,
                      }"
                    >
                      Travel :
                      {{ formatToDecimal(travelBudgetTotal - 0) }}
                    </p>
                  </div>
                  <div class="square-container" v-if="marketingBudgetTotal > 0">
                    <p
                      class="square mr-1"
                      :style="{ backgroundColor: getBackgroundColor(5) }"
                    ></p>
                    <p
                      :style="{
                        color: selectedBodyTextColor,
                        fontFamily: selectedFontFamily,
                      }"
                    >
                      Marketing :
                      {{ formatToDecimal(marketingBudgetTotal - 0) }}
                    </p>
                  </div>
                  <div class="square-container" v-if="facilitiesBudgetTotal > 0">
                    <p
                      class="square mr-1"
                      :style="{ backgroundColor: getBackgroundColor(6) }"
                    ></p>
                    <p
                      :style="{
                        color: selectedBodyTextColor,
                        fontFamily: selectedFontFamily,
                      }"
                    >
                      Facilities :
                      {{ formatToDecimal(facilitiesBudgetTotal - 0) }}
                    </p>
                  </div>
  
                  <div class="square-container" v-if="programsBudgetTotal > 0">
                    <p
                      class="square mr-1"
                      :style="{ backgroundColor: getBackgroundColor(7) }"
                    ></p>
                    <p
                      :style="{
                        color: selectedBodyTextColor,
                        fontFamily: selectedFontFamily,
                      }"
                    >
                      Programs :
                      {{ formatToDecimal(programsBudgetTotal - 0) }}
                    </p>
                  </div>
                  <div class="square-container" v-if="otherBudgetTotal > 0">
                    <p
                      class="square mr-1"
                      :style="{ backgroundColor: getBackgroundColor(8) }"
                    ></p>
                    <p
                      :style="{
                        color: selectedBodyTextColor,
                        fontFamily: selectedFontFamily,
                      }"
                    >
                      Other Expenses :
                      {{ formatToDecimal(otherBudgetTotal - -0) }}
                    </p>
                  </div>
  
                  <!-- In Kind Section -->
                  <div class="square-container" v-if="inKindBudgetTotal > 0">
                    <p
                      class="square mr-1"
                      :style="{ backgroundColor: getBackgroundColor(9) }"
                    ></p>
                    <p
                      :style="{
                        color: selectedBodyTextColor,
                        fontFamily: selectedFontFamily,
                      }"
                    >
                      In-Kind Goods & Services :
                      {{ formatToDecimal(inKindBudgetTotal - 0) }}
                    </p>
                  </div>
                </div>
              </div>
  
              <div class="w-full flex justify-center font-medium">
                <p
                  class="text-xl mt-3"
                  :style="{
                    color: selectedBodyTextColor,
                    fontFamily: selectedFontFamily,
                    lineHeight: '15px',
                  }"
                >
                  Total Expenses:
                  <span class="">{{
                    formatToDecimal(
                      +personnelBudgetTotal +
                        +professionalContractualBudgetTotal +
                        +printingBudgetTotal +
                        +travelBudgetTotal +
                        +marketingBudgetTotal +
                        +facilitiesBudgetTotal +
                        +programsBudgetTotal +
                        +otherBudgetTotal +
                        +inKindBudgetTotal -
                        0
                    )
                  }}</span>
                </p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </template>
  <script setup>
  //v Vue Imports
  import { ref, onMounted, reactive, computed, watch } from "vue";
  
  //v Vue Router
  import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
  const router = useRouter();
  
  // v Chart js
  import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
  import { Pie } from "vue-chartjs";
  
  import chroma from "chroma-js";
  
  ChartJS.register(ArcElement, Tooltip, Legend);
  
  import ActivityIndicator from "@/components/ActivityIndicator.vue";
  import { useExpenseStore } from '@/stores/useExpenseStore';
  
  
  //v Global
  import global from "@/global";
  
  //v Pinia Store: Auth
  import { useAuthStore } from "@/stores/auth";
  const authStore = useAuthStore();
  import { useRoutesManagement } from "@/stores/routesManagement";
  const routesManagementStore = useRoutesManagement();
  
  const props = defineProps({
    selectedFontFamily: String,
    selectedHeadingsColor: String,
    selectedBodyTextColor: String,
    expensesData: Object, // Add this new prop
  });
  
  // Total Expenses
  const expenseStore = useExpenseStore();
  
  //v State
  const isLoading = ref(true);
  const conformationPopupIsOpen = ref(false);
  const conformDeletionState = ref(null);
  const deletionFunction = ref(null);
  
  const videoUrl = ref("https://www.youtube.com/embed/gcevHkNGrWQ");
  const videoTitle = ref("Instructions");
  const bodyText = ref(``);
  
  const tooltipStatus = ref(false);
  
  const stepWindow = ref(null);
  
  const personalPointListContainer = ref(null);
  const financePointListContainer = ref(null);
  const legalPointListContainer = ref(null);
  const printingPointListContainer = ref(null);
  const travelPointListContainer = ref(null);
  const marketingExpensesContainer = ref(null);
  const otherExpensesContainer = ref(null);
  const programsExpensesContainer = ref(null);
  const inKindExpensesContainer = ref(null);
  
  const coreProgramsButton = ref(null);
  const tooltip = ref(``);
  
  let nearestColors = ref([]);
  
  const findNearestColors = () => {
    const colorValue = props.selectedHeadingsColor || '#00423D';
    const targetChroma = chroma(colorValue);
    const hue = targetChroma.get("hsl.h");
    const steps = 10;
    const stepSize = 100 / (steps - 1);
    let nearestColorsTmp = [];
    for (let i = 0; i < steps; i++) {
      const lightness = i * stepSize;
      // Avoid white (lightness 100%) and very light colors
      const adjustedLightness = lightness >= 90 ? lightness - 25 : lightness;
      nearestColorsTmp.push(`hsl(${hue}, 100%, ${adjustedLightness}%)`);
    }
    nearestColors = nearestColorsTmp;
  };
  
  findNearestColors();
  
  function getBackgroundColor(index) {
    return nearestColors[index];
  }
  
  //v Chart State
  const chartState = reactive({
    chartData: {
      labels: [
        "Personnel and Benefits",
        "Professional and Contractual Fees",
        "Printing and Publications",
        "Travel, Conferences, and Meetings",
        "Marketing and Communications",
        "Facilities",
        "Programs",
        "Other Expenses",
        "In-Kind Goods & Services"
      ],
      datasets: [
        {
          backgroundColor: [],
          borderWidth: 0,
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
    },
  });
  
  const computedChartData = computed(() => {
    return chartState.chartData;
  });
  
  const updatedChartData = computed(() => {
    findNearestColors();
    chartState.chartData.datasets[0].backgroundColor = [
      nearestColors[1],
      nearestColors[2],
      nearestColors[3],
      nearestColors[4],
      nearestColors[5],
      nearestColors[6],
      nearestColors[7],
      nearestColors[8],
      nearestColors[9],
    ];
    return chartState.chartData;
  });
  
  const chartOptions = ref({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        titleColor: "#0D423D",
        titleFont: {
          weight: "normal",
          size: 15,
        },
        padding: 10,
        borderColor: "#0D423D",
        borderWidth: 1,
        titleAlign: "center",
        bodyColor: "#0D423D",
        bodyAlign: "center",
        bodyFont: {
          weight: "bold",
          size: 14,
        },
        usePointStyle: true,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
  
            if (label) {
              label += ": ";
            }
  
            if (context.parsed !== null) {
              label += context.parsed.toLocaleString();
            }
            return label;
          },
          labelPointStyle: function (context) {
            return {
              pointStyle: "circle",
              rotation: 0,
            };
          },
        },
      },
    },
  });
  
  const forceRerenderChart = ref(true);
  
  //v Handling Personnel Budget Expenses
  const personnelBudgetTotal = ref(0);
  const isPersonnelBudgetValid = ref({ isValid: true, issue: "none" });
  const personnelBudgetPointList = ref([]);
  const personnelBudgetCompRef = ref(null);
  
  function onPersonnelBudgetChange(budgetList) {
    personnelBudgetPointList.value = budgetList;
    //v calculate total
    if (budgetList.length != 0) {
      let total = 0;
      budgetList.forEach((point) => {
        total +=
          point.pointValue == "" || isNaN(parseFloat(point.pointValue))
            ? 0
            : parseFloat(point.pointValue);
      });
      personnelBudgetTotal.value =
        parseFloat(total) == 0 ? parseFloat(total) : parseFloat(total).toFixed(2);
    } else {
      personnelBudgetTotal.value = parseFloat("00.0");
    }
  
    chartState.chartData.datasets[0].data[0] = parseFloat(
      personnelBudgetTotal.value
    );
  }
  
  function checkPersonnelBudgetValidation() {
    if (personnelBudgetPointList.value.length === 0) {
      isPersonnelBudgetValid.value = { isValid: false, issue: "empty" };
      return;
    }
  
    for (let i = 0; i < personnelBudgetPointList.value.length; i++) {
      const point = personnelBudgetPointList.value[i];
      if (!point.pointText || !point.pointValue) {
        isPersonnelBudgetValid.value = { isValid: false, issue: "incomplete" };
        return;
      }
    }
    isPersonnelBudgetValid.value = { isValid: true, issue: "none" };
  }
  
  watch(
    personnelBudgetPointList,
    (newObj) => {
      if (!isPersonnelBudgetValid.value.isValid) {
        isPersonnelBudgetValid.value = { isValid: true, issue: "none" };
      }
    },
    { deep: true }
  );
  
  //v Handling Professional and Contractual Fees Budget Expenses
  const professionalContractualBudgetTotal = ref(0);
  const isProfessionalContractualBudgetValid = ref({ isValid: true, issue: "none" });
  const professionalContractualBudgetPointList = ref([]);
  const professionalContractualBudgetCompRef = ref(null);
  
  function onProfessionalContractualBudgetChange(budgetList) {
    professionalContractualBudgetPointList.value = budgetList;
    //v calculate total
    if (budgetList.length != 0) {
      let total = 0;
      budgetList.forEach((point) => {
        total +=
          point.pointValue == "" || isNaN(parseFloat(point.pointValue))
            ? 0
            : parseFloat(point.pointValue);
      });
      professionalContractualBudgetTotal.value =
        parseFloat(total) == 0 ? parseFloat(total) : parseFloat(total).toFixed(2);
    } else {
      professionalContractualBudgetTotal.value = parseFloat("00.0");
    }
  
    chartState.chartData.datasets[0].data[1] = parseFloat(
      professionalContractualBudgetTotal.value
    );
  }
  
  watch(
    professionalContractualBudgetPointList,
    (newObj) => {
      if (!isProfessionalContractualBudgetValid.value.isValid) {
        isProfessionalContractualBudgetValid.value = { isValid: true, issue: "none" };
      }
    },
    { deep: true }
  );
  
  //v Handling Printing Budget Expenses
  const printingBudgetTotal = ref(0);
  const isPrintingBudgetValid = ref({ isValid: true, issue: "none" });
  const printingBudgetPointList = ref([]);
  const printingBudgetCompRef = ref(null);
  
  function onPrintingBudgetChange(budgetList) {
    printingBudgetPointList.value = budgetList;
    //v calculate total
    if (budgetList.length != 0) {
      let total = 0;
      budgetList.forEach((point) => {
        total +=
          point.pointValue == "" || isNaN(parseFloat(point.pointValue))
            ? 0
            : parseFloat(point.pointValue);
      });
      printingBudgetTotal.value =
        parseFloat(total) == 0 ? parseFloat(total) : parseFloat(total).toFixed(2);
    } else {
      printingBudgetTotal.value = parseFloat("00.0");
    }
  
    chartState.chartData.datasets[0].data[2] = parseFloat(
      printingBudgetTotal.value
    );
  }
  
  watch(
    printingBudgetPointList,
    (newObj) => {
      if (!isPrintingBudgetValid.value.isValid) {
        isPrintingBudgetValid.value = { isValid: true, issue: "none" };
      }
    },
    { deep: true }
  );
  
  //v Handling Travel Budget Expenses
  const travelBudgetTotal = ref(0);
  const isTravelBudgetValid = ref({ isValid: true, issue: "none" });
  const travelBudgetPointList = ref([]);
  const travelBudgetCompRef = ref(null);
  
  function onTravelBudgetChange(budgetList) {
    travelBudgetPointList.value = budgetList;
    //v calculate total
    if (budgetList.length != 0) {
      let total = 0;
      budgetList.forEach((point) => {
        total +=
          point.pointValue == "" || isNaN(parseFloat(point.pointValue))
            ? 0
            : parseFloat(point.pointValue);
      });
      travelBudgetTotal.value =
        parseFloat(total) == 0 ? parseFloat(total) : parseFloat(total).toFixed(2);
    } else {
      travelBudgetTotal.value = parseFloat("00.0");
    }
  
    chartState.chartData.datasets[0].data[3] = parseFloat(
      travelBudgetTotal.value
    );
  }
  
  watch(
    travelBudgetPointList,
    (newObj) => {
      if (!isTravelBudgetValid.value.isValid) {
        isTravelBudgetValid.value = { isValid: true, issue: "none" };
      }
    },
    { deep: true }
  );
  
  //v Handling Marketing and Communications Expenses
  const marketingBudgetTotal = ref(0);
  const isMarketingBudgetValid = ref({ isValid: true, issue: "none" });
  const marketingBudgetPointList = ref([]);
  const marketingBudgetCompRef = ref(null);
  
  function onMarketingBudgetChange(budgetList) {
    marketingBudgetPointList.value = budgetList;
    //v calculate total
    if (budgetList.length != 0) {
      let total = 0;
      budgetList.forEach((point) => {
        total +=
          point.pointValue == "" || isNaN(parseFloat(point.pointValue))
            ? 0
            : parseFloat(point.pointValue);
      });
      marketingBudgetTotal.value =
        parseFloat(total) == 0 ? parseFloat(total) : parseFloat(total).toFixed(2);
    } else {
      marketingBudgetTotal.value = parseFloat("00.0");
    }
  
    chartState.chartData.datasets[0].data[4] = parseFloat(
      marketingBudgetTotal.value
    );
  }
  
  watch(
    marketingBudgetPointList,
    (newObj) => {
      if (!isMarketingBudgetValid.value.isValid) {
        isMarketingBudgetValid.value = { isValid: true, issue: "none" };
      }
    },
    { deep: true }
  );
  
  //v Handling Facilities Budget Expenses
  const facilitiesBudgetTotal = ref(0);
  const isFacilitiesBudgetValid = ref({ isValid: true, issue: "none" });
  const facilitiesBudgetPointList = ref([]);
  const facilitiesBudgetCompRef = ref(null);
  
  function onFacilitiesBudgetChange(budgetList) {
    facilitiesBudgetPointList.value = budgetList;
    //v calculate total
    if (budgetList.length != 0) {
      let total = 0;
      budgetList.forEach((point) => {
        total +=
          point.pointValue == "" || isNaN(parseFloat(point.pointValue))
            ? 0
            : parseFloat(point.pointValue);
      });
      facilitiesBudgetTotal.value =
        parseFloat(total) == 0 ? parseFloat(total) : parseFloat(total).toFixed(2);
    } else {
      facilitiesBudgetTotal.value = parseFloat("00.0");
    }
  
    chartState.chartData.datasets[0].data[5] = parseFloat(
      facilitiesBudgetTotal.value
    );
  }
  
  watch(
    facilitiesBudgetPointList,
    (newObj) => {
      if (!isFacilitiesBudgetValid.value.isValid) {
        isFacilitiesBudgetValid.value = { isValid: true, issue: "none" };
      }
    },
    { deep: true }
  );
  
  //v Handling Other Expenses
  const otherBudgetTotal = ref(0);
  const isOtherBudgetValid = ref({ isValid: true, issue: "none" });
  const otherBudgetPointList = ref([]);
  const otherBudgetCompRef = ref(null);
  
  function onOtherBudgetChange(budgetList) {
    otherBudgetPointList.value = budgetList;
    //v calculate total
    if (budgetList.length != 0) {
      let total = 0;
      budgetList.forEach((point) => {
        total +=
          point.pointValue == "" || isNaN(parseFloat(point.pointValue))
            ? 0
            : parseFloat(point.pointValue);
      });
      otherBudgetTotal.value =
        parseFloat(total) == 0 ? parseFloat(total) : parseFloat(total).toFixed(2);
    } else {
      otherBudgetTotal.value = parseFloat("00.0");
    }
  
    chartState.chartData.datasets[0].data[7] = parseFloat(otherBudgetTotal.value);
  }
  
  watch(
    otherBudgetPointList,
    (newObj) => {
      if (!isOtherBudgetValid.value.isValid) {
        isOtherBudgetValid.value = { isValid: true, issue: "none" };
      }
    },
    { deep: true }
  );
  
  //v Handling Programs Expenses
  const programsBudgetTotal = ref(0);
  const isProgramsBudgetValid = ref({ isValid: true, issue: "none" });
  const programsBudgetPointList = ref([]);
  const programsBudgetCompRef = ref(null);
  
  function onProgramBudgetChange(budgetList) {
    programsBudgetPointList.value = budgetList;
    //v calculate total
    if (budgetList.length != 0) {
      let total = 0;
      budgetList.forEach((point) => {
        total +=
          point.pointValue == "" || isNaN(parseFloat(point.pointValue))
            ? 0
            : parseFloat(point.pointValue);
      });
      programsBudgetTotal.value =
        parseFloat(total) == 0 ? parseFloat(total) : parseFloat(total).toFixed(2);
    } else {
      programsBudgetTotal.value = parseFloat("00.0");
    }
  
    chartState.chartData.datasets[0].data[6] = parseFloat(
      programsBudgetTotal.value
    );
  }
  
  watch(
    programsBudgetPointList,
    (newObj) => {
      if (!isProgramsBudgetValid.value.isValid) {
        isProgramsBudgetValid.value = { isValid: true, issue: "none" };
      }
    },
    { deep: true }
  );
  
  // In Kind Budget States
  const inKindBudgetTotal = ref(0);
  const isInKindBudgetValid = ref({ isValid: true, issue: "none" });
  const inKindBudgetPointList = ref([]);
  const inKindBudgetCompRef = ref(null);
  
  // Handle In Kind Budget Changes
  function onInKindBudgetChange(budgetList) {
    inKindBudgetPointList.value = budgetList;
    // Calculate total
    if (budgetList.length !== 0) {
      let total = 0;
      budgetList.forEach((point) => {
        total +=
          point.pointValue === "" || isNaN(parseFloat(point.pointValue))
            ? 0
            : parseFloat(point.pointValue);
      });
      inKindBudgetTotal.value =
        parseFloat(total) === 0
          ? parseFloat(total)
          : parseFloat(total).toFixed(2);
    } else {
      inKindBudgetTotal.value = parseFloat("00.0");
    }
  
    chartState.chartData.datasets[0].data[8] = parseFloat(inKindBudgetTotal.value);
  }
  
  // Validate In Kind Budget
  function checkInKindBudgetValidation() {
    if (inKindBudgetPointList.value.length === 0) {
      isInKindBudgetValid.value = { isValid: false, issue: "empty" };
      return;
    }
  
    for (let i = 0; i < inKindBudgetPointList.value.length; i++) {
      const point = inKindBudgetPointList.value[i];
      if (!point.pointText || !point.pointValue) {
        isInKindBudgetValid.value = { isValid: false, issue: "incomplete" };
        return;
      }
    }
    isInKindBudgetValid.value = { isValid: true, issue: "none" };
  }
  
  // Watch In Kind Budget Changes
  watch(
    inKindBudgetPointList,
    (newObj) => {
      if (!isInKindBudgetValid.value.isValid) {
        isInKindBudgetValid.value = { isValid: true, issue: "none" };
      }
    },
    { deep: true }
  );
  
  // Watch for changes and set total expenses
  
  watch(
    [personnelBudgetTotal, professionalContractualBudgetTotal, printingBudgetTotal, travelBudgetTotal, marketingBudgetTotal, facilitiesBudgetTotal, programsBudgetTotal, otherBudgetTotal, inKindBudgetTotal],
    (newValues) => {
      const totalExpenses = newValues.reduce((acc, curr) => acc + parseFloat(curr || 0), 0);
      expenseStore.setTotalExpenses(totalExpenses);
    },
    { immediate: true }
  );
  
  //v watch chart state and rerender chart on chart data change
  watch(
    chartState,
    (newData, oldData) => {
      forceRerenderChart.value = false;
      setTimeout(() => {
        forceRerenderChart.value = true;
      }, 1);
    },
    { immediate: true }
  );
  
  //v request/response actions
  
  //v Getting Question
  // import { useFetchCache } from "@/composables/fetchCache.js";
  // const { error, fetchCachedData, cachedData } = useFetchCache({
  //   uri: "/questions/annual_programs_expenses",
  //   headers: {
  //     Authorization: `Bearer ${authStore.user.accessToken}`,
  //   },
  // });
  
  //v request/response actions
  // import { useFetch } from "@/composables/fetch.js";
  import formatToDecimal from "../../composables/formatToDecimal";
  // error, fetchCachedData, cachedData
  // const expensesFetch = useFetch({
  //   uri: "/expenses",
  //   headers: {
  //     Authorization: `Bearer ${authStore.user.accessToken}`,
  //   },
  // });
  
  //v Saving user answer
  // import { usePostAnswer } from "@/composables/postAnswer.js";
  // const answerPost = usePostAnswer({
  //   uri: `/expenses`,
  //   headers: {
  //     Authorization: `Bearer ${authStore.user.accessToken}`,
  //     "Content-Type": "application/json",
  //   },
  // });
  
  //v request/response actions
  
  const retrievedUserAnswer = ref(null);
  onMounted(async () => {
    try {
      // Check if we have expenses data from props
      if (props.expensesData) {
        const tempRes = props.expensesData;
        
        // Personnel and Benefits
        if (tempRes.personnel_and_benefits !== undefined) {
          personnelBudgetTotal.value = parseFloat(tempRes.personnel_and_benefits || 0);
          chartState.chartData.datasets[0].data[0] = personnelBudgetTotal.value;
        }

        // Professional and Contractual Fees
        if (tempRes.professional_and_contractual_fees !== undefined) {
          professionalContractualBudgetTotal.value = parseFloat(tempRes.professional_and_contractual_fees || 0);
          chartState.chartData.datasets[0].data[1] = professionalContractualBudgetTotal.value;
        }

        // Printing and Publications
        if (tempRes.printing_and_publications !== undefined) {
          printingBudgetTotal.value = parseFloat(tempRes.printing_and_publications || 0);
          chartState.chartData.datasets[0].data[2] = printingBudgetTotal.value;
        }

        // Travel, Conferences, and Meetings
        if (tempRes.travel_conferences_and_meetings !== undefined) {
          travelBudgetTotal.value = parseFloat(tempRes.travel_conferences_and_meetings || 0);
          chartState.chartData.datasets[0].data[3] = travelBudgetTotal.value;
        }

        // Marketing and Communications
        if (tempRes.marketing_and_communications !== undefined) {
          marketingBudgetTotal.value = parseFloat(tempRes.marketing_and_communications || 0);
          chartState.chartData.datasets[0].data[4] = marketingBudgetTotal.value;
        }

        // Facilities
        if (tempRes.facilities !== undefined) {
          facilitiesBudgetTotal.value = parseFloat(tempRes.facilities || 0);
          chartState.chartData.datasets[0].data[5] = facilitiesBudgetTotal.value;
        }

        // Programs (note: your API uses 'programs_cost' instead of 'programs')
        if (tempRes.programs_cost !== undefined) {
          programsBudgetTotal.value = parseFloat(tempRes.programs_cost || 0);
          chartState.chartData.datasets[0].data[6] = programsBudgetTotal.value;
        }

        // Other Expenses
        if (tempRes.other_expenses !== undefined) {
          otherBudgetTotal.value = parseFloat(tempRes.other_expenses || 0);
          chartState.chartData.datasets[0].data[7] = otherBudgetTotal.value;
        }

        // In Kind (note: your API uses 'in_kind_goods_and_services' instead of 'in-kind_goods_services')
        if (tempRes.in_kind_goods_and_services !== undefined) {
          inKindBudgetTotal.value = parseFloat(tempRes.in_kind_goods_and_services || 0);
          chartState.chartData.datasets[0].data[8] = inKindBudgetTotal.value;
        }

        // Force chart to update
        forceRerenderChart.value = false;
        setTimeout(() => {
          forceRerenderChart.value = true;
        }, 1);
      }
    } catch (error) {
      console.error('Error processing expenses data:', error);
    } finally {
      isLoading.value = false;
    }
  });

  // Add a watcher to update chart when expensesData changes
  watch(
    () => props.expensesData,
    (newExpensesData) => {
      if (newExpensesData) {
        // Personnel and Benefits
        if (newExpensesData.personnel_and_benefits !== undefined) {
          personnelBudgetTotal.value = parseFloat(newExpensesData.personnel_and_benefits || 0);
          chartState.chartData.datasets[0].data[0] = personnelBudgetTotal.value;
        }

        // Professional and Contractual Fees
        if (newExpensesData.professional_and_contractual_fees !== undefined) {
          professionalContractualBudgetTotal.value = parseFloat(newExpensesData.professional_and_contractual_fees || 0);
          chartState.chartData.datasets[0].data[1] = professionalContractualBudgetTotal.value;
        }

        // Printing and Publications
        if (newExpensesData.printing_and_publications !== undefined) {
          printingBudgetTotal.value = parseFloat(newExpensesData.printing_and_publications || 0);
          chartState.chartData.datasets[0].data[2] = printingBudgetTotal.value;
        }

        // Travel, Conferences, and Meetings
        if (newExpensesData.travel_conferences_and_meetings !== undefined) {
          travelBudgetTotal.value = parseFloat(newExpensesData.travel_conferences_and_meetings || 0);
          chartState.chartData.datasets[0].data[3] = travelBudgetTotal.value;
        }

        // Marketing and Communications
        if (newExpensesData.marketing_and_communications !== undefined) {
          marketingBudgetTotal.value = parseFloat(newExpensesData.marketing_and_communications || 0);
          chartState.chartData.datasets[0].data[4] = marketingBudgetTotal.value;
        }

        // Facilities
        if (newExpensesData.facilities !== undefined) {
          facilitiesBudgetTotal.value = parseFloat(newExpensesData.facilities || 0);
          chartState.chartData.datasets[0].data[5] = facilitiesBudgetTotal.value;
        }

        // Programs
        if (newExpensesData.programs_cost !== undefined) {
          programsBudgetTotal.value = parseFloat(newExpensesData.programs_cost || 0);
          chartState.chartData.datasets[0].data[6] = programsBudgetTotal.value;
        }

        // Other Expenses
        if (newExpensesData.other_expenses !== undefined) {
          otherBudgetTotal.value = parseFloat(newExpensesData.other_expenses || 0);
          chartState.chartData.datasets[0].data[7] = otherBudgetTotal.value;
        }

        // In Kind
        if (newExpensesData.in_kind_goods_and_services !== undefined) {
          inKindBudgetTotal.value = parseFloat(newExpensesData.in_kind_goods_and_services || 0);
          chartState.chartData.datasets[0].data[8] = inKindBudgetTotal.value;
        }

        // Force chart to update
        forceRerenderChart.value = false;
        setTimeout(() => {
          forceRerenderChart.value = true;
        }, 1);
      }
    },
    { immediate: true, deep: true }
  );
  </script>
  <style scoped>
  .answer-err-enter-active,
  .answer-err-leave-active {
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  }
  
  .answer-err-enter-from {
    opacity: 0;
    transform: translateY(-10px);
  }
  
  .answer-err-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }
  .chart-container {
    margin-top:  8px;
    min-height: 400px;
    max-height:450px;
    overflow: hidden;
  }
  .chart-content {
    width: 155px !important;
    height: 155px !important;
  }
  .content-container {
    margin-bottom: 10px
  }
  .square-container .square {
    position: absolute;
    top: 0;
    left: 0;
    width: 10px;
    height: 10px;
    margin-top: 5.9px;
  }
  .square-container {
    position: relative;
    padding-left: 1rem;
  }
  .square-container {
    text-align: left;
  }
  </style>
  